module.exports = __webpack_public_path__ + "img/skull_2.b4290df6.png";